import { useCallback, useEffect, useState } from 'react';
import { Button, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { PreworkCandidateFilter } from '../../../shared/PreWorkServiceTypes';
import RegionsDropdown from '../../../components/RegionsDropdown';
import { useAuth } from '../../../hooks/useAuth';
import isEmpty from 'lodash/isEmpty';
import { COUNTRY_CODE_INDIA } from '../../../shared/Constants';

interface FilterProps {
	value?: PreworkCandidateFilter;
	onFilterChange: (value: PreworkCandidateFilter) => void;
	selectedBatchId: number | undefined;
}

const { Text } = Typography;

interface RegionData {
	value: number | undefined;
	label: string | undefined;
}

export const FilterGraphsPreWork = ({
	value,
	onFilterChange,
	selectedBatchId,
}: FilterProps) => {
	const { t } = useTranslation();
	const { srcmId } = useAuth();
	const [selectedRegion, setSelectedRegion] = useState<RegionData | undefined>(
		undefined
	);

	const handleFilterButtonClick = useCallback(() => {
		const filterValues: PreworkCandidateFilter = {
			...value,
			showAllCandidates: true,
			regionIds: selectedRegion?.value ? [selectedRegion?.value] : [],
			batchId: selectedBatchId,
		};
		onFilterChange(filterValues);
	}, [onFilterChange, selectedRegion?.value, value, selectedBatchId]);

	const handleResetForm = useCallback(() => {
		setSelectedRegion(undefined);
		const filterValues: PreworkCandidateFilter = {
			...value,
			showAllCandidates: true,
			countryIds: [COUNTRY_CODE_INDIA],
			regionIds: [] as Array<number>,
			batchId: selectedBatchId,
		};
		onFilterChange(filterValues);
	}, [onFilterChange, value, selectedBatchId]);

	useEffect(() => {
		setSelectedRegion(undefined);
		const filterValues: PreworkCandidateFilter = {
			showAllCandidates: true,
			countryIds: [COUNTRY_CODE_INDIA],
			batchId: selectedBatchId,
		};
		onFilterChange(filterValues);
	}, [onFilterChange, selectedBatchId]);

	const handleRegionChange = useCallback((reg: RegionData) => {
		setSelectedRegion(reg);
	}, []);

	return (
		<div className="flex flex-col mb-4">
			<div className="flex flex-col md:mb-0">
				<div className="flex flex-col gap-4 md:flex-row">
					<div className="flex flex-col md:mb-0 min-w-[170px]">
						<Text className="pl-1">{t('selectRegion')}</Text>
						<RegionsDropdown
							value={selectedRegion}
							functionarySrcmId={srcmId}
							onChange={handleRegionChange}
							getPreworkRegions={true}
							batchId={selectedBatchId}
							getRegionChange={true}
						/>
					</div>
				</div>
			</div>
			<div className="flex flex-row gap-2 md:mb-0">
				<div className="self-start my-2">
					<Button
						type="primary"
						disabled={isEmpty(selectedRegion)}
						onClick={handleFilterButtonClick}
					>
						{t('search')}
					</Button>
				</div>
				<div className="self-start my-2">
					<Button type="default" onClick={handleResetForm}>
						{t('clear')}
					</Button>
				</div>
			</div>
		</div>
	);
};
